import tinycolor from "tinycolor2";

export const isDark = (color) => {
  const brightness = tinycolor(color).getBrightness();
  return brightness < 100;
};
